declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ttq: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TiktokAnalyticsObject?: any
  }
}

export default function () {
  const { data: {
    meta,
    google,
    // snapchat,
  } } = getData()

  const gAnalytics = useScriptGoogleAnalytics({
    id: google.id,
    scriptInput: {
      defer: true,
    },
    scriptOptions: {
      // bundle: true,
      trigger: google.enable ? 'onNuxtReady' : 'manual',
    },
  })

  const metaPixel = useScriptMetaPixel({
    id: meta.id,
    scriptOptions: {
      // bundle: true,
      trigger: meta.enable ? 'onNuxtReady' : 'manual',
    },
  })

  // const snapPixel = useScriptSnapchatPixel({
  //   id: snapchat.id,
  //   scriptOptions: {
  //     // bundle: true,
  //     trigger: snapchat.enable ? 'onNuxtReady' : 'manual',
  //   },
  // })

  return {
    gAnalytics,
    metaPixel,
    // snapPixel,
    snapPixel: undefined,
  }
}
